import { render, staticRenderFns } from "./InfosTPE.vue?vue&type=template&id=70dc11af&scoped=true"
import script from "./InfosTPE.vue?vue&type=script&lang=js"
export * from "./InfosTPE.vue?vue&type=script&lang=js"
import style0 from "./InfosTPE.vue?vue&type=style&index=0&id=70dc11af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc11af",
  null
  
)

export default component.exports